import React from 'react';
import { Drawer, Descriptions, Tag, Divider, Typography } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const AuditDrawer = ({ visible, onClose, data }) => {
    if (!data) return null;

    const getActionColor = (action) => {
        switch (action) {
            case 'CREATE': return 'green';
            case 'UPDATE': return 'blue';
            case 'DELETE': return 'red';
            case 'LOGIN': return 'gold';
            case 'LOGOUT': return 'volcano';
            default: return 'default';
        }
    };

    return (
        <Drawer
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <AuditOutlined style={{ color: '#DA291C' }} />
                    <span>Detalle de Auditoría</span>
                </div>
            }
            width={600}
            onClose={onClose}
            open={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Title level={4}>Información General</Title>
            <Descriptions column={1} bordered size="small">
                <Descriptions.Item label="Timestamp">
                    {new Date(data.timestamp).toLocaleString()}
                </Descriptions.Item>
                <Descriptions.Item label="Usuario">
                    <Text strong>{data.user_name}</Text>
                </Descriptions.Item>
                <Descriptions.Item label="Módulo">
                    {data.module_name || '-'}
                </Descriptions.Item>
                <Descriptions.Item label="Acción">
                    <Tag color={getActionColor(data.action_type)}>{data.action_type}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Entidad">
                    <Tag>{data.entity_name || 'N/A'}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="ID de Item">
                    {data.item_id || 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="IP Origen">
                    {data.ip_address}
                </Descriptions.Item>
            </Descriptions>

            <Divider />

            <Title level={4}>Detalle del Evento</Title>
            <div style={{
                background: '#f5f5f5',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                fontFamily: 'monospace',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
            }}>
                {data.event_details}
            </div>

            {data.metadata && (
                <>
                    <Divider />
                    <Title level={4}>Metadatos Técnicos</Title>
                    <pre style={{
                        background: '#fafafa',
                        padding: '12px',
                        fontSize: '12px',
                        overflowX: 'auto'
                    }}>
                        {JSON.stringify(JSON.parse(data.metadata), null, 2)}
                    </pre>
                </>
            )}
        </Drawer>
    );
};

export default AuditDrawer;
